import { AApi } from './AApi';
import type { ApiResult } from '../types/api.types';
import type { AppInfoBody } from '../types/app.types';

/**
 * The calls about the installation itself, independent of a module.
 */
export class AppApi extends AApi {
    /** GET /appInfo — static information; loaded by AppInfoService, not with the polled `/whoAmI`. */
    public getAppInfo(): Promise<ApiResult<AppInfoBody>> {
        return this.Client.get<AppInfoBody>(`${this.VersionPath}/appInfo`);
    }
}
